<template>
  <DatePicker
      ref="dateRange"
      type="daterange"
      v-model="search.value"
      :placeholder="'请输入' + search.label"
      :transfer="true"
      @on-change="handleChange"
      @on-ok="emitSearchQuery"
  ></DatePicker>
</template>

<script>
export default {
  props: {
    search: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  created () {
    // this.search.value = this.search.value || '';
  },
  watch: {
  },
  computed: {
  },
  methods: {
    handleChange (dateRange, date) {
      const _self = this;
      _self.search.value = dateRange;
      // 将值往上传
      _self.$emit('getSearchValueChange', _self.search);
    },
    emitSearchQuery () {
      const _self = this;
      // 自动执行查询
      _self.$emit('enter');
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/regularQuery/dateRange.vue